import { Component, Input } from '@angular/core';
import { IxBaseLookupComponent } from 'ix-ng-components';
import { ObcinaLookupDTO } from './obcina-lookup.model';

@Component({
  selector: 'lib-obcina-lookup',
  template: `
    <header class="{{ this.lookupClass }}">
      <div class="lookup-header flex-wrap">
        <div class="col-12" style="word-break:break-word;">{{ this.lookupHeader }}</div>
      </div>
    </header>
    @if (!this.header) {
      <div class="lookup-body flex-wrap">
        <div class="col-12" style="word-break:break-word;">
          {{ item.naziv }}
        </div>
      </div>
    }
  `,
})
export class ObcinaLookupComponent extends IxBaseLookupComponent {
  @Input()
  override item!: ObcinaLookupDTO;
  @Input()
  public lookupHeader?: string;
  @Input()
  public sifraHeader?: string;
}
